<div class="no-data">
  <ng-content [ngStyle]="{
    'font-size': fontSize,
    'color': color
  }"></ng-content>
</div>
